import { __assign, __rest } from "tslib";
import React from "react";
import Svg from "./Svg";

var SvgUserAlt = function SvgUserAlt(_a) {
  var _b = _a.size,
      size = _b === void 0 ? 24 : _b,
      props = __rest(_a, ["size"]);

  return React.createElement(Svg, __assign({
    fill: "currentColor",
    viewBox: "0 0 24 24",
    size: size
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M12 3.047c1.078 0 2.016.89 2.016 2.015A2 2 0 0112 7.079c-1.078 0-2.016-.89-2.016-2.016 0-1.125.938-2.015 2.016-2.015zm0-2.016a3.981 3.981 0 00-3.984 3.985A3.981 3.981 0 0012 9a3.981 3.981 0 003.984-3.984A3.981 3.981 0 0012 1.03zM12 12.984c3.281 0 6 2.672 6 6C18 20.062 17.11 21 15.984 21H8.016C6.937 21 6 20.11 6 18.984c.047-3.28 2.719-6 6-6zm0-1.968a7.962 7.962 0 00-7.969 7.968 3.981 3.981 0 003.985 3.985h7.968a3.981 3.981 0 003.985-3.985A7.962 7.962 0 0012 11.016z"
  }));
};

export default SvgUserAlt;